import React from 'react';

export type BadgeVariant = 'default' | 'fire' | 'cyan';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

/**
 * Badge component for status indicators and labels
 * Variants:
 * - default: Standard badge with subtle styling
 * - fire: Fire accent badge for highlights and active states
 * - cyan: Cyan accent badge for completed states
 */
export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  className = '' 
}) => {
  const variantClass = variant === 'fire' ? 'badgeFire' : variant === 'cyan' ? 'badgeCyan' : '';

  return (
    <span className={`badge ${variantClass} ${className}`}>
      {children}
    </span>
  );
};
